/*
 * gw-copyfix.js — corrects copy that assets/gw-hike.js injects into the PDP.
 *
 * Why this file exists instead of an edit to gw-hike.js: that file is a build artefact
 * (it ends in a sourceMappingURL and is minified), so its source is not in the theme and a
 * hand-edit would be overwritten by the next build. This runs after it and fixes the text.
 *
 * What it corrects, and why:
 *   1. "Tested & recommended by podiatrists" / "Four design principles hand therapists and
 *      podiatrists recommend" — Solework has no podiatrist endorsement. A fabricated
 *      professional endorsement is the kind of claim the ACCC and the TGA read literally.
 *   2. "Engineered for all-day, pain-free comfort" — "pain-free" is a health claim on a
 *      product that is not a medical device.
 *   3. "Bundle offer ends tonight" — a deadline that resets every night is not a deadline.
 *
 * It also ADDS a fifth "Heel that holds" card to the gw-hike feature grid (see the second
 * IIFE below): the wide-forefoot / narrow-heel fit wedge that no competitor runs. Same
 * reason it lives here and not in gw-hike.js — that file is a minified build artefact.
 *
 * STILL FABRICATED AND STILL LIVE (deliberately left alone, pending a decision):
 * the "SELLOUT RISK: High" badge, the "Excellent 5.0 · 2,715 reviews" rating and its
 * distribution popup, the 19-review wall in pdpWall(), and "Trusted by thousands of Aussie
 * walkers". All of it is invented. Removing it changes the page that produced the only
 * sales this store has had, so it is a commercial call rather than a cleanup.
 */
(function () {
  var FIXES = [
    [/^\s*Tested\s*&\s*recommended by podiatrists\s*$/i, 'How they are built'],
    [/^\s*Engineered for all-day, pain-free comfort\s*$/i, 'Built around the shape of a foot'],
    [/^\s*Four design principles hand therapists and podiatrists recommend for a healthier foot\.?\s*$/i, 'Four things we do differently, and what each one is for.'],
    [/^\s*Bundle offer ends tonight\s*$/i, 'Buy more, pay less per pair']
  ];

  function sweep(root) {
    if (!root || root.nodeType !== 1) return;
    var nodes = root.querySelectorAll('h2, h3, p, span, div');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;
      var t = el.textContent;
      if (!t) continue;
      for (var f = 0; f < FIXES.length; f++) {
        if (FIXES[f][0].test(t)) { el.textContent = FIXES[f][1]; break; }
      }
    }
  }

  function run() {
    sweep(document.body);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) { sweep(n); sweep(n.parentElement); }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/*
 * Heel-hold pillar. gw-hike.js injects a four-card "how they are built" grid (.gw-featx__g)
 * with Wide toe box / Natural alignment / Thin flexible / Zero-drop. This adds a fifth card
 * for heel security — the one benefit pairing (room up front, locked at the heel) that the
 * VOC research found no competitor advertises. Inserted as the second card so it sits next
 * to "Wide toe box", and the grid is widened to five columns with its own responsive rules.
 * It also RELOCATES the whole section above the reviews: gw-hike injects it just before the
 * "You may also like" block (i.e. below the review wall), but it reads as product education,
 * so it belongs above the "In their words" reviews.
 */
(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;
  var done = false;

  function add() {
    if (done) return;
    var grid = document.querySelector('.gw-featx__g');
    if (!grid) return;
    // 1. add the fifth "Heel that holds" pillar (once)
    if (!grid.querySelector('.gw-heelpillar')) {
      var card = document.createElement('div');
      card.className = 'gw-featx__i gw-heelpillar';
      card.innerHTML = '<span class="gw-featx__w">SECURE</span>'
        + '<h3 class="gw-featx__n">Heel that holds</h3>'
        + '<p class="gw-featx__b">A snug heel and true-to-shape midfoot hold your foot in place — so you can size up for toe room without your heel sliding out.</p>';
      grid.insertBefore(card, grid.children[1] || null);

      if (!document.getElementById('gw-heel-css')) {
        var st = document.createElement('style');
        st.id = 'gw-heel-css';
        st.textContent = '.gw-featx .gw-featx__g{grid-template-columns:repeat(5,minmax(0,1fr))}'
          + '@media(max-width:1000px){.gw-featx .gw-featx__g{grid-template-columns:repeat(3,1fr)}}'
          + '@media(max-width:640px){.gw-featx .gw-featx__g{grid-template-columns:repeat(2,1fr)}}'
          + '@media(max-width:460px){.gw-featx .gw-featx__g{grid-template-columns:1fr}}';
        document.head.appendChild(st);
      }
    }

    // 2. move the whole "How they are built" section above the reviews ("In their words")
    var feat = document.querySelector('.gw-featx');
    if (feat) {
      var reviews = [].slice.call(document.querySelectorAll('.shopify-section, section')).filter(function (s) {
        return /In their words/i.test(s.textContent || '') && (s.textContent || '').length < 8000 && !s.contains(feat) && !feat.contains(s);
      })[0];
      if (reviews && reviews.parentNode && feat.nextElementSibling !== reviews) {
        reviews.parentNode.insertBefore(feat, reviews);
      }
    }
    done = true;
  }

  function run() {
    add();
    if (done) return;
    var mo = new MutationObserver(function () { add(); if (done) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
